import { defineStore } from 'pinia'
import { constantRoutes, router } from '@/router'
import { store } from '@/store'
import MainLayout from '@/layouts/MainLayout.vue'
import { useUserStore } from "@/store/modules/user"

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    routes: [...constantRoutes],
    dynamicRoutes: [],
    isRoutesLoaded: false
  }),

  actions: {
    formatRoutes(groups) {
      // 主框架路由
      const mainRoute = {
        path: '/',
        name: 'MainLayout',
        component: MainLayout,
        children: []
      };
    
      // 处理每个分组
      Object.entries(groups).forEach(([groupName, routes]) => {
        if (!Array.isArray(routes)) return;
        
        routes.forEach(item => {
          const pathWithOptionalParam = item.path + (item.path.endsWith('/') ? '' : '/') + ':param?';
          mainRoute.children.push({
            path: pathWithOptionalParam,
            name: item.name || `route-${groupName}-${item.path.replace(/\//g, '-')}`,
            component: () => import(`@/view${item.component}.vue`).then(m => m.default || m),
            meta: {
              title: item.title || `${groupName}默认标题`,
              noCache: true,
              group: groupName, // 添加分组标识
              ...(item.meta || {})
            }
          });
        });
      });
    
      return mainRoute;
    }, 
       

    // 生成动态路由
    async generateRoutes() {
      try {
        if (this.isRoutesLoaded) return

        const userStore = useUserStore()
        const menuData = userStore.user.rule
        console.log(menuData);
        // 1. 格式化路由
        const dynamicRoute = this.formatRoutes(menuData)  
        console.log(dynamicRoute)
        // 2. 添加404路由
        dynamicRoute.children.push({
          path: '/:pathMatch(.*)*',
          name: 'NotFound',
          redirect: '/404',
          meta: { hidden: true }
        })

        // 3. 动态添加到路由实例
        router.addRoute(dynamicRoute)
        
        // 4. 更新store状态
        this.dynamicRoutes = dynamicRoute.children
        this.routes = [...constantRoutes, dynamicRoute]
        this.isRoutesLoaded = true
        
        return dynamicRoute
      } catch (err) {
        console.error('路由加载失败:', err)
        return {
          path: '/',
          component: MainLayout,
          children: []
        }
      }
    },

    // 重置路由（改进版）
    resetRoutes() {
      // 移除所有动态路由
      this.dynamicRoutes.forEach(route => {
        if (route.name) {
          router.removeRoute(route.name)
        }
      })
      
      // 重置状态
      this.$reset()
      this.isRoutesLoaded = false
    }
  }
})

// 非setup环境使用
export function usePermissionStoreHook() {
  return usePermissionStore(store)
}